<template>
  <div class="main-wrapper">
    <div class="btn-wrapper">
      <el-button icon="el-icon-plus" type="primary" @click="addModal('新增')">新增员工</el-button>
    </div>
    <ex-table showPagination :data="tableData" :height="tableHeight" ref="table"
              :search-method="handleChange" border>
      <ex-table-col prop="name" label="姓名"></ex-table-col>
      <ex-table-col prop="phoneNumber" label="电话号码"></ex-table-col>
      <ex-table-col prop="identityCard" label="证件号"></ex-table-col>
      <ex-table-col prop="education" label="学历"></ex-table-col>
      <ex-table-col prop="post" label="工种"></ex-table-col>
      <ex-table-col prop="residencePlace" label="住所"></ex-table-col>
      <ex-table-col :width="100" label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button title="编辑" class="circle-btn" type="primary" @click="edit(scope.row)" icon="el-icon-edit" circle></el-button>
          <el-button title="删除" class="circle-btn" type="primary" @click="removeEm(scope.row.id)" icon="el-icon-delete" circle></el-button>
        </template>
      </ex-table-col>
    </ex-table>
    <edit-modal :row-id="currentId" :title="currentTitle" v-if="isShowEdit" @ok="onModalOk" @close="isShowEdit=false" :mode="editMode"></edit-modal>
  </div>
</template>
<script>
  import pageMixin from "@/mixin/tablePage"
  import editModal from "./edit"
  import {putAction, deleteAction} from "@/service/http/api";

  export default {
    name:'EmployeeManagement',
    mixins:[pageMixin],
    components:{
      'edit-modal':editModal
    },
    data(){
      return{
        tableHeight: window.innerHeight - 290,
        page: 1,
        pageSize: 10,
        tableData:[],
        currentId:null,
        isShowEdit:false,
        currentTitle:null,
        editMode:'new',
        reqParams:{},
        url:{
          list:'/employee/employeeInfo/list',
          remove:'/employee/employeeInfo/delete'
        }
      }
    },
    methods:{
      edit(row){
        this.currentTitle = '编辑' + row.name ;
        this.currentId = row.id;
        this.editMode = 'edit';
        this.isShowEdit = true;
      },
      removeEm(rowId){
        this.$confirm('确定删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteAction(this.url.remove,{id:rowId}).then(res=>{
            if(res.code===200){
              this.$message({
                message:'删除成功',
                type:"success"
              });
              this.loadData();
            }
          })
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/employee_management/employee_management.vue